/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetUserForMagicQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetUserForMagicQuery = {
  readonly __typename: "Query";
  readonly me: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly userMagicConfig: c.UserMagicConfig;
  } | null;
};

export const GetUserForMagicDocument = /*#__PURE__*/ gql`
  query GetUserForMagic {
    me {
      id
      userMagicConfig
    }
  }
`;

/**
 * __useGetUserForMagicQuery__
 *
 * To run a query within a React component, call `useGetUserForMagicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserForMagicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserForMagicQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserForMagicQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserForMagicQuery, GetUserForMagicQueryVariables>(
    GetUserForMagicDocument,
    options,
  );
}
export function useGetUserForMagicLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >(GetUserForMagicDocument, options);
}
export function useGetUserForMagicSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetUserForMagicQuery,
    GetUserForMagicQueryVariables
  >(GetUserForMagicDocument, options);
}
export type GetUserForMagicQueryHookResult = ReturnType<
  typeof useGetUserForMagicQuery
>;
export type GetUserForMagicLazyQueryHookResult = ReturnType<
  typeof useGetUserForMagicLazyQuery
>;
export type GetUserForMagicSuspenseQueryHookResult = ReturnType<
  typeof useGetUserForMagicSuspenseQuery
>;
export type GetUserForMagicQueryResult = Apollo.QueryResult<
  GetUserForMagicQuery,
  GetUserForMagicQueryVariables
>;
